import React from "react"
import { useTranslation } from "react-i18next"

import { Layout } from "~/components/Layout/Layout"

import { Content } from "./components/Content/Content"
import { Hero } from "./components/Hero/Hero"

const ConflictCommission: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout
      description={t("conflictCommission.Hero.Lead")}
      headerTheme="onDark"
      title={t("page.conflict-commission")}
    >
      <Hero />
      <Content />
    </Layout>
  )
}

export default ConflictCommission
